// Modal Size Population Script - Production Version
(function() {
  
  // Flag to prevent multiple popups
  let successPopupShown = false;
  
  // Check if form was successfully submitted (after page refresh)
  function checkFormSubmissionStatus() {
    // Prevent multiple executions
    if (successPopupShown) return;
    
    // Check sessionStorage for MODAL form submission flag ONLY
    const wasFormJustSubmitted = sessionStorage.getItem('modalFormSubmitted') === 'true';
    
    // Check if we came from a product page with modal form
    const referrer = document.referrer;
    const isFromSameSite = referrer && new URL(referrer).hostname === window.location.hostname;
    
    // ONLY show popup if the modal form was specifically submitted
    if (wasFormJustSubmitted && isFromSameSite) {
      // Set flag immediately to prevent multiple popups
      successPopupShown = true;
      
      showSuccessPopup();
      
      // Clear the flag
      sessionStorage.removeItem('modalFormSubmitted');
    }
  }
  
  // Function to show success popup
  function showSuccessPopup() {
    // Additional check to prevent multiple popups
    if (document.querySelector('.form-success-popup-overlay')) {
      return;
    }
    
    // Create popup overlay
    const overlay = document.createElement('div');
    overlay.className = 'form-success-popup-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;
    
    // Create popup content
    const popup = document.createElement('div');
    popup.className = 'form-success-popup';
    popup.style.cssText = `
      background: var(--color-primary-background, #fff);
      border-radius: 12px;
      padding: 40px;
      max-width: 500px;
      width: 90%;
      text-align: center;
      transform: scale(0.9);
      transition: transform 0.3s ease;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    `;
    
    popup.innerHTML = `
      <div style="margin-bottom: 20px;">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="30" fill="#2ea043" fill-opacity="0.1"/>
          <path d="M20 30L26 36L40 22" stroke="#2ea043" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h2 style="margin: 0 0 15px 0; color: var(--text-color, #333); font-size: 24px;">Bedankt voor uw reservering!</h2>
      <p style="margin: 0 0 25px 0; color: var(--text-color, #666); font-size: 16px; line-height: 1.5;">
        <strong>Deze reservering staat 4 dagen voor u apart, om te komen passen in onze winkel.</strong><br>
        <strong>Tot snel</strong>.
      </p>
      <button class="btn" style="padding: 12px 30px; font-size: 16px;">Sluiten</button>
    `;
    
    overlay.appendChild(popup);
    document.body.appendChild(overlay);
    
    // Trigger animations
    setTimeout(() => {
      overlay.style.opacity = '1';
      popup.style.transform = 'scale(1)';
    }, 10);
    
    // Close popup function
    const closePopup = () => {
      overlay.style.opacity = '0';
      popup.style.transform = 'scale(0.9)';
      setTimeout(() => {
        overlay.remove();
        // Reset flag after popup is removed (in case user navigates back)
        successPopupShown = false;
      }, 300);
    };
    
    // Close on button click
    popup.querySelector('button').addEventListener('click', closePopup);
    
    // Close on overlay click
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closePopup();
    });
    
    // Close on escape key
    document.addEventListener('keydown', function escapeHandler(e) {
      if (e.key === 'Escape') {
        closePopup();
        document.removeEventListener('keydown', escapeHandler);
      }
    });
    
    // Auto-close after 10 seconds
    setTimeout(closePopup, 10000);
  }
  
  // Function to get the selected size from the active swatch
  function getSelectedSize() {
    const activeSwatch = document.querySelector('.swatch-element.active[data-value]');
    if (activeSwatch) {
      return activeSwatch.getAttribute('data-value');
    }
    return null;
  }
  
  // Function to find and update the size input
  function updateModalSizeInput() {
    // Look for input with name="contact[size]" or id starting with modal_form_size_
    const sizeInput = document.querySelector('input[name="contact[maat]"]') || 
                     document.querySelector('input[id^="modal_form_size_"]');
    
    if (!sizeInput) {
      return false;
    }
    
    const selectedSize = getSelectedSize();
    
    if (selectedSize) {
      sizeInput.value = selectedSize;
      
      // Trigger events to ensure any listeners are notified
      sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      sizeInput.dispatchEvent(new Event('input', { bubbles: true }));
      
      // Also try setting via setAttribute as backup
      sizeInput.setAttribute('value', selectedSize);
      
      return true;
    } else {
      return false;
    }
  }
  
  // Function to initialize date picker
  // Function to initialize date picker
  // Function to initialize date picker
  function initializeDatePicker() {
    // Check if mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth <= 767;
    
    // Find all date inputs (both mobile and desktop versions)
    const dateInputs = document.querySelectorAll('input[data-date-input="true"], input[name="contact[ophaaldatum]"], input[id^="modal_form_date_"]');
    
    dateInputs.forEach(dateInput => {
      // Skip if already initialized
      if (dateInput.hasAttribute('data-date-initialized')) {
        return;
      }
      
      // Mark as initialized
      dateInput.setAttribute('data-date-initialized', 'true');
      
      // Get min date
      const minDate = dateInput.getAttribute('data-min-date') || new Date().toISOString().split('T')[0];
      
      // For mobile inputs (the ones with _mobile suffix), apply same logic as desktop
      if (dateInput.id && dateInput.id.includes('_mobile')) {
        const originalPlaceholder = dateInput.placeholder;
        let isConverted = false;
        
        function convertToDatePicker(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          
          if (!isConverted) {
            dateInput.type = 'date';
            dateInput.setAttribute('min', minDate);
            isConverted = true;
            
            // Set a default date (e.g., tomorrow) if empty
            if (!dateInput.value) {
              const tomorrow = new Date();
              tomorrow.setDate(tomorrow.getDate() + 1);
              dateInput.value = tomorrow.toISOString().split('T')[0];
            }
          }
          
          // Try to open the date picker
          setTimeout(() => {
            dateInput.focus();
            if (typeof dateInput.showPicker === 'function') {
              try {
                dateInput.showPicker();
              } catch (err) {
                dateInput.click();
              }
            }
          }, 50);
        }
        
        function handleBlur() {
          setTimeout(() => {
            if (!dateInput.value && isConverted) {
              dateInput.type = 'text';
              dateInput.placeholder = originalPlaceholder;
              dateInput.removeAttribute('min');
              isConverted = false;
            }
          }, 200);
        }
        
        // Add event listeners for mobile inputs
        dateInput.addEventListener('click', convertToDatePicker);
        dateInput.addEventListener('focus', function() {
          if (!isConverted) {
            convertToDatePicker();
          }
        });
        dateInput.addEventListener('blur', handleBlur);
        
        return; // No further initialization needed for mobile
      }
      
      // For mobile devices, convert desktop inputs to date immediately
      if (isMobile && !dateInput.id.includes('_mobile')) {
        // This is a desktop input on a mobile device - hide it
        const wrapper = dateInput.closest('.modal-desktop-date-wrapper, .desktop-date-input');
        if (wrapper) {
          wrapper.style.display = 'none';
        } else {
          dateInput.style.display = 'none';
        }
        
        // Make sure the mobile input is visible
        const formId = dateInput.id;
        const mobileInput = document.getElementById(formId + '_mobile');
        if (mobileInput) {
          mobileInput.style.display = 'block';
          mobileInput.type = 'date';
          mobileInput.setAttribute('min', minDate);
          
          // Set a default date for mobile
          if (!mobileInput.value) {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            mobileInput.value = tomorrow.toISOString().split('T')[0];
          }
        }
        return;
      }
      
      // Desktop functionality (text to date transformation)
      if (!isMobile && !dateInput.id.includes('_mobile')) {
        const originalPlaceholder = dateInput.placeholder;
        let isConverted = false;
        
        function convertToDatePicker(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          
          if (!isConverted) {
            dateInput.type = 'date';
            dateInput.setAttribute('min', minDate);
            isConverted = true;
            
            // Convert DD-MM-YYYY to YYYY-MM-DD if present
            if (dateInput.value && dateInput.value.match(/^\d{2}-\d{2}-\d{4}$/)) {
              const [day, month, year] = dateInput.value.split('-');
              dateInput.value = `${year}-${month}-${day}`;
            }
          }
          
          // Try to open the date picker
          setTimeout(() => {
            dateInput.focus();
            if (typeof dateInput.showPicker === 'function') {
              try {
                dateInput.showPicker();
              } catch (err) {
                // showPicker not supported, try click
                dateInput.click();
              }
            }
          }, 50);
        }
        
        function handleBlur() {
          setTimeout(() => {
            if (!dateInput.value && isConverted) {
              dateInput.type = 'text';
              dateInput.placeholder = originalPlaceholder;
              dateInput.removeAttribute('min');
              isConverted = false;
            }
          }, 200);
        }
        
        // Add event listeners for desktop
        dateInput.addEventListener('click', convertToDatePicker);
        dateInput.addEventListener('focus', function() {
          if (!isConverted) {
            convertToDatePicker();
          }
        });
        dateInput.addEventListener('blur', handleBlur);
        
        // If input has value on load, convert to date
        if (dateInput.value) {
          dateInput.type = 'date';
          dateInput.setAttribute('min', minDate);
          isConverted = true;
        }
      }
    });
    
    // Handle visibility of mobile vs desktop inputs based on screen size
    function handleDateInputVisibility() {
      const isMobileView = window.innerWidth <= 767;
      
      // Find all date input wrappers
      document.querySelectorAll('.modal-desktop-date-wrapper, .desktop-date-input').forEach(wrapper => {
        wrapper.style.display = isMobileView ? 'none' : 'block';
      });
      
      // Find all mobile date inputs
      document.querySelectorAll('.modal-mobile-date-input, input[id$="_mobile"][type="date"]').forEach(input => {
        input.style.display = isMobileView ? 'block' : 'none';
      });
    }
    
    // Initial visibility check
    handleDateInputVisibility();
    
    // Add resize listener for responsive behavior
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleDateInputVisibility, 250);
    });
  }
  
  // Function to handle form submission
  function initializeFormSubmission() {
    // Find all modal contact forms
    const forms = document.querySelectorAll('.modal-contact-form--form');
    
    forms.forEach(form => {
      // Skip if already initialized
      if (form.hasAttribute('data-form-initialized')) return;
      
      form.setAttribute('data-form-initialized', 'true');
      
      // Add submit handler to clean up hidden duplicate fields before submission
      form.addEventListener('submit', function(e) {
        // Remove hidden duplicate ophaaldatum fields before submission
        const allOphaaldatumInputs = form.querySelectorAll('input[name="contact[ophaaldatum]"]');
        
        if (allOphaaldatumInputs.length > 1) {
          // Find and remove truly hidden ophaaldatum fields (display: none or not visible)
          const hiddenInputs = Array.from(allOphaaldatumInputs).filter(input => {
            const style = window.getComputedStyle(input);
            return input.offsetParent === null || style.display === 'none' || style.visibility === 'hidden';
          });
          
          hiddenInputs.forEach(hiddenInput => {
            hiddenInput.remove(); // Remove the hidden input from DOM
          });
        }
        
        // Also check for duplicate maat fields
        const allMaatInputs = form.querySelectorAll('input[name="contact[maat]"]');
        if (allMaatInputs.length > 1) {
          const hiddenMaatInputs = Array.from(allMaatInputs).filter(input => input.offsetParent === null);
          hiddenMaatInputs.forEach(hiddenInput => {
            hiddenInput.remove();
          });
        }
        
        // Set a flag in sessionStorage before the page refreshes
        sessionStorage.setItem('modalFormSubmitted', 'true');
      }, true);
    });
  }
  
  // Function to wait for modal to be fully rendered
  function waitForModalAndUpdate() {
    let attempts = 0;
    const maxAttempts = 20;
    
    const checkAndUpdate = function() {
      attempts++;
      
      // Check if modal content exists
      const modalContent = document.querySelector('.theme-modal-content, .modal-contact-form, [data-modal-content]');
      
      // Try to update size
      const sizeSuccess = updateModalSizeInput();
      
      // Initialize date picker
      initializeDatePicker();
      
      // Initialize form submission
      initializeFormSubmission();
      
      if (!sizeSuccess && attempts < maxAttempts) {
        setTimeout(checkAndUpdate, 100);
      }
    };
    
    // Start checking
    setTimeout(checkAndUpdate, 100);
  }
  
  // Initialize
  function init() {
    // Listen for modal button clicks
    document.addEventListener('click', function(e) {
      // Check if clicked element or its parent is a modal button
      const modalButton = e.target.closest('[data-modal-button]');
      if (modalButton) {
        waitForModalAndUpdate();
      }
    });
    
    // Also listen for any element with modal class being clicked
    document.addEventListener('click', function(e) {
      if (e.target.matches('.product-block-modal, .btn-modal, [class*="modal"]')) {
        waitForModalAndUpdate();
      }
    });
    
    // Watch for DOM changes (when modal template content is inserted)
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) { // Element node
            // Check if it's modal-related or contains our inputs
            if (node.querySelector && (node.querySelector('input[name="contact[maat]"]') || node.querySelector('input[name="contact[ophaaldatum]"]'))) {
              setTimeout(() => {
                updateModalSizeInput();
                initializeDatePicker();
                initializeFormSubmission();
              }, 50);
            } else if (node.matches && (node.matches('.theme-modal-content') || node.matches('[data-modal-content]'))) {
              setTimeout(() => {
                updateModalSizeInput();
                initializeDatePicker();
                initializeFormSubmission();
              }, 100);
            }
          }
        }
      }
    });
    
    // Observe entire document for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      checkFormSubmissionStatus();
    });
  } else {
    init();
    checkFormSubmissionStatus();
  }
})();